import { gql } from '@apollo/client';

export const NOTIFY_LXP_FILE = gql`
    mutation notifyLxpFileUploaded( $input: NotifyLxpFileUploadedInput! ){
        result: notifyLxpFileUploaded(input: $input) {
            id
            name
            filename
        }
    }
`;
